// @ts-nocheck
import React, { useMemo } from 'react';
import intl from 'react-intl-universal';
import styled from 'styled-components';
import {
  Menu,
  Button,
  MenuItem,
  MenuDivider,
  Intent,
  Tag,
  ButtonGroup,
} from '@blueprintjs/core';
import { Icon } from '@/components';
import { safeCallback } from '@/utils';

/**
 * Row actions menu list.
 */
export function ActionMenuList({
  row: { original },
  payload: { onEditSalesPeople, onDeleteSalespeople },
}) {
  return (
    <Menu>
      <MenuItem
        icon={<Icon icon="pen-18" />}
        text={intl.get('edit_currency')}
        onClick={safeCallback(onEditSalesPeople, original)}
      />
      <MenuDivider />
      <MenuItem
        icon={<Icon icon="trash-16" iconSize={16} />}
        text={intl.get('delete_currency')}
        onClick={safeCallback(onDeleteSalespeople, original)}
        intent={Intent.DANGER}
      />
    </Menu>
  );
}

/**
 * Actions cell.
 */
export const ActionsCell = ({
  row: { original },
  payload: { onEditSalesPeople, onDeleteSalespeople  },
}) => {
  return (
    <ButtonGroup>
      <Button
        icon={<Icon icon={'pen-18'} iconSize={13} />}
        iconSize={14}
        className="m12"
        minimal={true}
        onClick={safeCallback(onEditSalesPeople, original)}
        style={{ marginRight: '5px' }}
      />
      <Button
        intent={Intent.DANGER}
        icon={<Icon icon={'trash'} iconSize={13} />}
        iconSize={14}
        className="m12"
        minimal={true}
        onClick={safeCallback(onDeleteSalespeople, original)}
        style={{ color: '#FF0000' }}
      />
    </ButtonGroup>
  );
};


// export const CurrencyNameAccessor = (value) => {
//   return (
//     <CurrencyNameRoot>
//       {value.currency_name} {value.is_base_currency && <Tag>Base Currency</Tag>}
//     </CurrencyNameRoot>
//   );
// };

const CurrencyNameRoot = styled.div`
  display: flex;
  gap: 8px;
`;

export function useSalesPeopleTableColumns() {
  return useMemo(
    () => [
      {
        Header: intl.get('name'),
        accessor: 'name',
        width: 150,
      },
      {
        Header: intl.get('email'),
        accessor: 'email',
        className: 'email',
        width: 120,
      },
      {
        Header: intl.get('status'),
        width: 120,
        accessor: 'status',
      },
      {
        id: 'actions',
        Header: 'Action',
        Cell: ActionsCell,
        className: 'actions',
        width: 100,
        disableResizing: true,
      },
    ],
    [],
  );
}
